import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordStrengthValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const password = control.value;
	if (!password) return null;

	const hasUpperCase = /[A-Z]/.test(password);
	const hasLowerCase = /[a-z]/.test(password);
	const hasNumeric = /[0-9]/.test(password);
	const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password);
	const hasNoSpaces = !/\s/.test(password);
	
	const weakPasswords = ['password', '12345678', 'password123', 'admin123', 'qwerty', '123456789'];
	const isNotWeak = !weakPasswords.includes(password.toLowerCase());

	if (!hasUpperCase || !hasLowerCase || !hasNumeric || !hasSpecialChar || !hasNoSpaces || !isNotWeak) {
		return {
			passwordStrength: {
				hasUpperCase,
				hasLowerCase,
				hasNumeric,
				hasSpecialChar,
				hasNoSpaces,
				isNotWeak
			}
		};
	}

	return null;
};

export const passwordCrossFieldValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const password = control.get('password');
	const confirmPassword = control.get('confirm_password');
	const email = control.get('email') || control.get('poc_email');
	const officialEmail = control.get('official_email');
	const firstName = control.get('first_name') || control.get('poc_name');
	const lastName = control.get('last_name');

	const errors: any = {};

	if (password?.value && confirmPassword?.value && password.value !== confirmPassword.value) {
		errors.passwordMismatch = true;
	}

	if (password?.value) {
		const lowerPass = password.value.toLowerCase();
		if (email?.value && lowerPass === email.value.toLowerCase()) {
			errors.passwordIsEmail = true;
		}
		if (officialEmail?.value && lowerPass === officialEmail.value.toLowerCase()) {
			errors.passwordIsEmail = true;
		}
		if (firstName?.value && lowerPass === firstName.value.toLowerCase()) {
			errors.passwordIsName = true;
		}
		if (lastName?.value && lowerPass === lastName.value.toLowerCase()) {
			errors.passwordIsName = true;
		}
	}

	return Object.keys(errors).length > 0 ? errors : null;
};
